// src/themeSearchWords.js

export const THEME_DATA = [
  // 1 - 50: ???????? ??????? ????????
  "SHARK,WHALE,FISH,CRAB,SEAL,TIDE",
  "CORAL,REEF,SAND,SHELL,CLAM,WAVE",
  "OCTOPUS,SQUID,EEL,RAY,ORCA,KELP",
  "TUNA,SALMON,COD,BASS,TROUT,PRAWN",
  "KRILL,BELUGA,MANATEE,SEAHORSE,URN,SPONGE",
  "STARFISH,URCHIN,ANEMONE,GULL,MANTA,TRENCH",
  "ABYSS,SCUBA,DIVER,BOAT,SHIP,SAIL",
  "DOCK,PIER,GULF,BAY,COAST,SHORE",
  "ISLE,ATOLL,COVE,SURF,FOAM,BRINE",
  "WATER,DEEP,BLUE,SALT,GROUPER,SNAPPER",
  "SUNFISH,GUPPY,TETRA,KOI,CARP,PIKE",
  "MOLLUSK,CONCH,PEARL,WRECK,ANCHOR,SONAR",
  "HOOK,BAIT,NET,LINE,REEL,CATCH",
  "CREW,NAVY,OCEAN,SHARK,CRAB,REEF",
  "WHALE,SEAL,CLAM,SQUID,ORCA,TUNA",
  "COD,TROUT,KRILL,MANTA,DIVER,SAIL",
  "BAY,ISLE,SURF,WATER,SALT,GUPPY",
  "CARP,CONCH,ANCHOR,BAIT,LINE,CREW",
  "FISH,SAND,EEL,SALMON,BASS,PRAWN",
  "BELUGA,URCHIN,GULL,TRENCH,BOAT,DOCK",
  "COAST,ATOLL,FOAM,DEEP,GROUPER,SUNFISH",
  "TETRA,PIKE,PEARL,SONAR,NET,REEL",
  "CATCH,NAVY,OCEAN,TIDE,WAVE,KELP",
  "SEAHORSE,ANEMONE,ABYSS,SHIP,PIER,SHORE",
  "COVE,BRINE,BLUE,SNAPPER,KOI,MOLLUSK",
  "WRECK,HOOK,CRAB,SHELL,RAY,TUNA",
  "BASS,BELUGA,STARFISH,MANTA,SCUBA,SAIL",
  "GULF,ISLE,FOAM,SALT,TETRA,CONCH",
  "ANCHOR,NET,CREW,SHARK,CORAL,OCTOPUS",
  "COD,KRILL,URCHIN,TRENCH,BOAT,COAST",
  "COVE,WATER,GROUPER,KOI,PEARL,BAIT",
  "CATCH,FISH,SAND,EEL,SALMON,PRAWN",
  "MANATEE,SPONGE,GULL,ABYSS,SHIP,SHORE",
  "SURF,DEEP,SUNFISH,PIKE,WRECK,LINE",
  "NAVY,WHALE,REEF,SQUID,ORCA,TROUT",
  "SEAHORSE,ANEMONE,DIVER,DOCK,ATOLL,BRINE",
  "BLUE,SNAPPER,MOLLUSK,SONAR,REEL,OCEAN",
  "SEAL,CLAM,RAY,TUNA,BELUGA,STARFISH",
  "SCUBA,GULF,FOAM,GUPPY,ANCHOR,NET",
  "SHARK,SHELL,COD,URCHIN,BOAT,COVE",
  "SALT,CONCH,CREW,CORAL,EEL,KRILL",
  "TRENCH,COAST,GROUPER,PEARL,FISH,SALMON",
  "SPONGE,ABYSS,SHORE,DEEP,PIKE,LINE",
  "WHALE,SQUID,TROUT,ANEMONE,DOCK,BRINE",
  "SNAPPER,SONAR,OCEAN,CLAM,TUNA,STARFISH",
  "GULF,GUPPY,NET,SHELL,URCHIN,COVE",
  "CONCH,CORAL,KRILL,COAST,PEARL,SALMON",
  "ABYSS,DEEP,LINE,SQUID,DOCK,SNAPPER",
  "OCEAN,TUNA,GULF,NET,URCHIN,CONCH",
  "KRILL,PEARL,ABYSS,LINE,DOCK,OCEAN",

  // 51 - 100: ???? ?????? ????????
  "MARLIN,OYSTER,DUGONG,PELICAN,FLEET,TREASURE",
  "MERMAID,SIREN,TRITON,ATLANTIS,SUNKEN,PIRATE",
  "CAPTAIN,ADMIRAL,WALRUS,ALGAE,BEACH,ROACH",
  "LOACH,NAUTILUS,KRAKEN,POSEIDON,ISLAND,MARINE",
  "AQUA,FLUID,LIQUID,SWIM,DIVE,FLOAT",
  "SINK,DROWN,GILLS,FINS,SCALES,TAIL",
  "FLIPPER,SNOUT,FANGS,BITE,JAWS,BLOOD",
  "PREY,HUNTER,KILLER,POISON,TOXIN,VENOM",
  "STING,BARB,SPINE,SHELL,CARAPACE,CLAWS",
  "PINCER,TENTACLE,SUCKER,BEAK,INK,CAMOUFLAGE",
  "HIDE,SEEK,FIND,LOST,DARK,COLD",
  "WARM,CURRENT,STREAM,RIVER,LAKE,POND",
  "POOL,PUDDLE,DROP,SPLASH,RIPPLE,WAVE",
  "TSUNAMI,STORM,WIND,GALE,BREEZE,CALM",
  "STILL,QUIET,SILENT,NOISE,SOUND,ECHO",
  "SONG,CALL,CRY,WHISTLE,CLICK,PULSE",
  "HEART,BEAT,LIFE,DEATH,BIRTH,GROW",
  "EGG,SPAWN,FRY,BABY,ADULT,OLD",
  "ANCIENT,FOSSIL,BONE,TEETH,SKULL,SKELETON",
  "RUIN,RELIC,ARTIFACT,GOLD,SILVER,COIN",
  "JEWEL,GEM,DIAMOND,RUBY,EMERALD,SAPPHIRE",
  "CROWN,KING,QUEEN,PRINCE,PALACE,CASTLE",
  "TOWER,WALL,GATE,DOOR,WINDOW,ROOF",
  "FLOOR,ROOM,HALL,CAVE,GROTTO,HOLE",
  "PIT,CRATER,CANYON,VALLEY,RIDGE,PEAK",
  "MOUNTAIN,HILL,MOUND,DUNE,SAND,DUST",
  "MUD,DIRT,ROCK,STONE,PEBBLE,GRAVEL",
  "WEED,PLANT,LEAF,STEM,ROOT,FLOWER",
  "BLOOM,SEED,FRUIT,BERRY,NUT,TREE",
  "WOOD,BARK,BRANCH,STICK,LOG,TIMBER",
  "BOARD,PLANK,BEAM,NAIL,SCREW,BOLT",
  "IRON,STEEL,METAL,RUST,DECAY,ROT",
  "SPOIL,FRESH,CLEAN,DIRTY,FOUL,PURE",
  "CLEAR,BRIGHT,SHINE,GLOW,SPARK,FIRE",
  "BURN,HEAT,WARM,COOL,CHILL,FREEZE",
  "ICE,SNOW,FROST,MELT,THAW,DRIP",
  "DROP,POUR,FLOW,RUSH,GUSH,SPURT",
  "SPRAY,MIST,FOG,CLOUD,RAIN,STORM",
  "THUNDER,LIGHT,FLASH,STRIKE,HIT,MISS",
  "CATCH,THROW,TOSS,PULL,PUSH,DRAG",
  "TOW,HAUL,LIFT,DROP,FALL,RISE",
  "SOAR,FLY,GLIDE,SWOOP,DIVE,SWIM",
  "FLOAT,DRIFT,SAIL,CRUISE,STEER,TURN",
  "SPIN,ROLL,ROCK,TOSS,PITCH,YAW",
  "PORT,STAR,BOW,STERN,DECK,HULL",
  "MAST,SAIL,RIG,ROPE,KNOT,TIE",
  "BIND,LOOSE,FREE,CATCH,TRAP,SNARE",
  "HOOK,BAIT,LURE,BITE,NIBBLE,CHEW",
  "SWALLOW,GULP,CHOKE,COUGH,SPIT,VOMIT",
  "SICK,ILL,WELL,HEALTH,CURE,HEAL",

  // 101 - 150: ??????? ????? ?????? ????
  "MEDIC,DOCTOR,NURSE,PILL,DRUG,WEED",
  "POISON,VENOM,TOXIN,STING,BITE,FANG",
  "CLAW,PINCER,BEAK,BILL,MOUTH,LIP",
  "TOOTH,TONGUE,THROAT,NECK,HEAD,BRAIN",
  "MIND,THOUGHT,IDEA,DREAM,SLEEP,WAKE",
  "REST,TIRED,WEARY,FRESH,NEW,OLD",
  "YOUNG,BOY,GIRL,MAN,WOMAN,CHILD",
  "BABY,KID,TEEN,ADULT,ELDER,SENIOR",
  "FAMILY,TRIBE,CLAN,GROUP,HERD,FLOCK",
  "SCHOOL,POD,SHOAL,SWARM,MOB,CROWD",
  "GANG,TEAM,CREW,BAND,PARTY,CLUB",
  "FISH,SHARK,WHALE,CRAB,SEAL,TIDE",
  "REEF,SAND,SHELL,CLAM,WAVE,ORCA",
  "KELP,TUNA,SALMON,COD,BASS,TROUT",
  "PRAWN,KRILL,BELUGA,GULL,MANTA,TRENCH",
  "ABYSS,SCUBA,DIVER,BOAT,SHIP,SAIL",
  "DOCK,PIER,GULF,BAY,COAST,SHORE",
  "ISLE,ATOLL,COVE,SURF,FOAM,BRINE",
  "WATER,DEEP,BLUE,SALT,GROUPER,SNAPPER",
  "SUNFISH,GUPPY,TETRA,KOI,CARP,PIKE",
  "MOLLUSK,CONCH,PEARL,WRECK,ANCHOR,SONAR",
  "HOOK,BAIT,NET,LINE,REEL,CATCH",
  "CREW,NAVY,OCEAN,SHARK,CRAB,REEF",
  "WHALE,SEAL,CLAM,ORCA,TUNA,COD",
  "TROUT,KRILL,MANTA,DIVER,SAIL,BAY",
  "ISLE,SURF,WATER,SALT,GUPPY,CARP",
  "CONCH,ANCHOR,BAIT,LINE,CREW,FISH",
  "SAND,SALMON,BASS,PRAWN,BELUGA,GULL",
  "TRENCH,BOAT,DOCK,COAST,ATOLL,FOAM",
  "DEEP,GROUPER,SUNFISH,TETRA,PIKE,PEARL",
  "SONAR,NET,REEL,CATCH,NAVY,OCEAN",
  "TIDE,WAVE,KELP,ABYSS,SHIP,PIER",
  "SHORE,COVE,BRINE,BLUE,SNAPPER,KOI",
  "MOLLUSK,WRECK,HOOK,CRAB,SHELL,TUNA",
  "BASS,BELUGA,MANTA,SCUBA,SAIL,GULF",
  "ISLE,FOAM,SALT,TETRA,CONCH,ANCHOR",
  "NET,CREW,SHARK,CORAL,OCTOPUS,COD",
  "KRILL,TRENCH,BOAT,COAST,COVE,WATER",
  "GROUPER,KOI,PEARL,BAIT,CATCH,FISH",
  "SAND,SALMON,PRAWN,SPONGE,GULL,ABYSS",
  "SHIP,SHORE,SURF,DEEP,SUNFISH,PIKE",
  "WRECK,LINE,NAVY,WHALE,REEF,ORCA",
  "TROUT,DIVER,DOCK,ATOLL,BRINE,BLUE",
  "SNAPPER,MOLLUSK,SONAR,REEL,OCEAN,SEAL",
  "CLAM,TUNA,BELUGA,SCUBA,GULF,FOAM",
  "GUPPY,ANCHOR,NET,SHARK,SHELL,COD",
  "BOAT,COVE,SALT,CONCH,CREW,CORAL",
  "KRILL,COAST,GROUPER,PEARL,FISH,SALMON",
  "SPONGE,ABYSS,SHORE,DEEP,PIKE,LINE",
  "WHALE,TROUT,DOCK,BRINE,SNAPPER,SONAR",

  // 151 - 200: ?????? ????? ??????? (Mix for variety)
  "OCEAN,CLAM,TUNA,GULF,GUPPY,NET",
  "SHELL,COVE,CONCH,CORAL,KRILL,COAST",
  "PEARL,SALMON,ABYSS,DEEP,LINE,DOCK",
  "SNAPPER,OCEAN,TUNA,GULF,NET,CONCH",
  "KRILL,PEARL,ABYSS,LINE,DOCK,OCEAN",
  "MARLIN,OYSTER,DUGONG,PELICAN,FLEET,TREASURE",
  "MERMAID,SIREN,TRITON,ATLANTIS,SUNKEN,PIRATE",
  "CAPTAIN,ADMIRAL,WALRUS,ALGAE,BEACH,ROACH",
  "LOACH,NAUTILUS,KRAKEN,POSEIDON,ISLAND,MARINE",
  "AQUA,FLUID,LIQUID,SWIM,DIVE,FLOAT",
  "SHARK,WHALE,FISH,CRAB,SEAL,TIDE",
  "CORAL,REEF,SAND,SHELL,CLAM,WAVE",
  "OCTOPUS,SQUID,EEL,RAY,ORCA,KELP",
  "TUNA,SALMON,COD,BASS,TROUT,PRAWN",
  "KRILL,BELUGA,MANATEE,SEAHORSE,URCHIN,SPONGE",
  "STARFISH,ANEMONE,GULL,MANTA,TRENCH,ABYSS",
  "SCUBA,DIVER,BOAT,SHIP,SAIL,DOCK",
  "PIER,GULF,BAY,COAST,SHORE,ISLE",
  "ATOLL,COVE,SURF,FOAM,BRINE,WATER",
  "DEEP,BLUE,SALT,GROUPER,SNAPPER,SUNFISH",
  "GUPPY,TETRA,KOI,CARP,PIKE,MOLLUSK",
  "CONCH,PEARL,WRECK,ANCHOR,SONAR,HOOK",
  "BAIT,NET,LINE,REEL,CATCH,CREW",
  "NAVY,OCEAN,SHARK,CRAB,REEF,WHALE",
  "SEAL,CLAM,SQUID,ORCA,TUNA,COD",
  "TROUT,KRILL,MANTA,DIVER,SAIL,BAY",
  "ISLE,SURF,WATER,SALT,GUPPY,CARP",
  "CONCH,ANCHOR,BAIT,LINE,CREW,FISH",
  "SAND,EEL,SALMON,BASS,PRAWN,BELUGA",
  "URCHIN,GULL,TRENCH,BOAT,DOCK,COAST",
  "ATOLL,FOAM,DEEP,GROUPER,SUNFISH,TETRA",
  "PIKE,PEARL,SONAR,NET,REEL,CATCH",
  "NAVY,OCEAN,TIDE,WAVE,KELP,SEAHORSE",
  "ANEMONE,ABYSS,SHIP,PIER,SHORE,COVE",
  "BRINE,BLUE,SNAPPER,KOI,MOLLUSK,WRECK",
  "HOOK,CRAB,SHELL,RAY,TUNA,BASS",
  "BELUGA,STARFISH,MANTA,SCUBA,SAIL,GULF",
  "ISLE,FOAM,SALT,TETRA,CONCH,ANCHOR",
  "NET,CREW,SHARK,CORAL,OCTOPUS,COD",
  "KRILL,URCHIN,TRENCH,BOAT,COAST,COVE",
  "WATER,GROUPER,KOI,PEARL,BAIT,CATCH",
  "FISH,SAND,EEL,SALMON,PRAWN,MANATEE",
  "SPONGE,GULL,ABYSS,SHIP,SHORE,SURF",
  "DEEP,SUNFISH,PIKE,WRECK,LINE,NAVY",
  "WHALE,REEF,SQUID,ORCA,TROUT,SEAHORSE",
  "ANEMONE,DIVER,DOCK,ATOLL,BRINE,BLUE",
  "SNAPPER,MOLLUSK,SONAR,REEL,OCEAN,SEAL",
  "CLAM,RAY,TUNA,BELUGA,STARFISH,SCUBA",
  "GULF,FOAM,GUPPY,ANCHOR,NET,SHARK",
  "SHELL,COD,URCHIN,BOAT,COVE,SALT"
];